/**
 * VERSIONE LIBRERIA 3
 */

var RenderMap = Render.extend({
    type : 'map',
    classData : 'map',
    classTemplate : 'map',
    _lat : 0,
    _lng : 0,
    _hasDbValues : false,
    address : null,
    lat_caption_selector : '[data-lat_field]',
    lng_caption_selector : '[data-lng_field]',
    lat_field_name : 'lat',
    lng_field_name : 'lng',
    dialogId : '#map_dialog',
    raggioArea : 5000,
    showArea : false,
    mapKey : null,

    getIndirizzo : function () {
        var self = this;
        return self.address?self.address:"";
    },

    _renderEdit : function (jQe) {
        var self = this;
        self._lat = self.value['lat'];
        self._lng = self.value['lng'];

        $(jQe).find(self.lat_caption_selector).html(self._lat);
        $(jQe).find(self.lng_caption_selector).html(self._lng);
    },

    _finalizeEdit : function () {
        var self = this;
        $(self.container).find('[data-button_map]').click(function () {
            $(self.dialogId).find('[data-lnk_address]').unbind('click');
            $(self.dialogId).find('[data-lnk_address]').click(function () {
                var address = $('#map_dialog').find('input[name="indirizzo"]').val();
                if (!address || address.length == 0) {
                    $.errorDialog("Inserire un indirizzo valido");
                    return ;
                }
                Render.mymap.updateMarkerAddress(0,address,function (result) {
                    //console.log("link usa indirizzo callback",result);
                    if (result.error == 0) {
                        $(self.dialogId).find('input[name="lat"]').attr('value',result.pos.lat()).val(result.pos.lat());
                        $(self.dialogId).find('input[name="lng"]').attr('value',result.pos.lng()).val(result.pos.lng());
                        self._lat = result.pos.lat();
                        self._lng = result.pos.lng();
                        Render.mymap.setCenter(self._lat ,self._lng);
                    } else {
                        $.errorDialog(result.msg);
                    }
                });

            });
            $.waitStart();
            self.activateMap(function () {
                $.waitEnd();
                self._showDialog();
            })

        })
    },
    _showDialog : function () {
        var self = this;


        var lat = self._lat;
        var lng = self._lng;
        log.info("_showDialog " + lat + ":" + lng +  " markers " + Render.mymap.markers.length);
        if (Render.mymap.markers.length == 0) {
            var marker = new GMapMarker();
            if (self.getIndirizzo())
                marker.address = self.getIndirizzo();
            //else {
            marker.lat = lat;
            marker.lng = lng;
            //}
            marker.draggable = true;

            log.debug("marker",marker);


            Render.mymap.addMarker(marker);
            Render.mymap.showQueued(function () {
                Render.mymap.markerToCenter(0);
                var marker = Render.mymap.markers[0];
                $(self.dialogId).find('input[name="'+self.lat_field_name+'"]').attr('value',marker.lat).val(marker.lat);
                $(self.dialogId).find('input[name="'+self.lng_field_name+'"]').attr('value',marker.lng).val(marker.lng);
            })
        } else {
            Render.mymap.updateMarker(0, {lat:lat,lng:lng});
        }
        $(self.dialogId).find('input[name="indirizzo"]').attr('value',self.getIndirizzo()).val(self.getIndirizzo());
        $(self.dialogId).find('input[name="lat"]').attr('value',lat);
        $(self.dialogId).find('input[name="lng"]').attr('value',lng);

        if (self.showArea) {
            $(self.dialogId).find('[data-area_container]').removeClass('hide');
            var input = $(self.dialogId).find('[data-input_raggio]');
            $(input).val(self.raggioArea);

            Render.mymap.showArea({raggio:parseInt($(input).val())})
            $(input).bind('change',function () {
                self.raggioArea = parseInt($(input).val());
                Render.mymap.showArea({raggio:parseInt($(input).val())})
            });

        }

        $(self.dialogId).modal('show').ok(function () {
            self._lat = Render.mymap.markers[0].lat;
            self._lng = Render.mymap.markers[0].lng;
            self.setLatLngValues();

        });

        setTimeout(function () {
            if (Render.mymap.markers[0].address) {
                $('#map_dialog').find('[data-lnk_address]').click();
            } else {
                Render.mymap.setCenter(lat,lng);
            }

        },1000);


    },
    setLatLngValues : function() {
        var self = this;
        //$(self.container).find('input[name="'+self.lat_field+'"]').val(self._lat).attr('value',self._lat);
        //$(self.container).find('input[name="'+self.lng_field+'"]').val(self._lng).attr('value',self._lng);
        $(self.container).find('[data-lat_field]').html(self._lat);
        $(self.container).find('[data-lng_field]').html(self._lng);
        var params = {}
        if (self.lat_field)
            params[self.lat_field] = self._lat;
        if (self.lng_field)
            params[self.lng_field] = self._lng;
        self._emitEvent('change',params);
    },
    activateMap : function(callback) {
        var self = this;
        if (!Render.mymap) {
            Render.mymap = new GMap('Render.mymap');
            Render.mymap.apiKey = self.mapKey;
            Render.mymap.elementId = "gmap";
            Render.mymap.zoom = 8;//parseInt($.cookie('zoom'))? parseInt($.cookie('zoom')): 16;
            Render.mymap.lat = self._lat;
            Render.mymap.lng = self._lng;
            Render.mymap.language = "it";
            Render.mymap.markerDragend = function (pos,marker) {
                log.debug('pos',pos.lat(),pos.lng());
                $('#map_dialog').find('input[name="lat"]').attr('value',pos.lat()).val(pos.lat());
                $('#map_dialog').find('input[name="lng"]').attr('value',pos.lng()).val(pos.lng());
                self._lat = pos.lat();
                self._lng = pos.lng();
            }
            Render.mymap.afterLoadScript = function() {
                //$.waitEnd();

            };
            Render.mymap.afterInitialize = function() {
                console.log('afterInitialize');
                setTimeout(function () {
                    google.maps.event.trigger(Render.mymap.gmap, 'resize');

                },500);
                //self._showDialog();
                callback();

            }
            Render.mymap.loadScript();

        } else {
           // $.waitEnd();
            //self._showDialog();
            setTimeout(function () {
                google.maps.event.trigger(Render.mymap.gmap, 'resize');

            },500);
            callback();
        }
    }
});